import {
  GoabContainer,
  GoabFormItem,
  GoabRadioGroup,
  GoabRadioItem,
  GoabSpacer,
} from "@abgov/react-components";

import { useGenerationForm } from "../../hooks";

export const AccountTypeSection = () => {
  const {
    fieldValues,
    fieldErrors,
    fieldTouches,
    handleVerificationChange,
    isReady,
  } = useGenerationForm();

  // Early return if form not ready.
  if (!isReady) return null;

  const verificationStatusError =
    fieldTouches.verificationStatus && fieldErrors.verificationStatus;

  return (
    <>
      <GoabContainer accent="thin">
        <h3>Account type</h3>

        <GoabSpacer vSpacing="l" />
        <GoabFormItem error={fieldErrors.verificationStatus}>
          <GoabRadioGroup
            name="verificationStatus"
            onChange={({name, value}) => handleVerificationChange(name, value)}
            orientation="vertical"
            value={fieldValues.verificationStatus.toString()}
            error={verificationStatusError}
          >
            <GoabRadioItem value="1" label="Basic"></GoabRadioItem>
            {/* <GoabRadioItem value="2" label="Pending"></GoabRadioItem> */}
            <GoabRadioItem value="3" label="Verified"></GoabRadioItem>
            <GoabRadioItem value="4" label="Proxy"></GoabRadioItem>
          </GoabRadioGroup>
        </GoabFormItem>
      </GoabContainer>
      <GoabSpacer vSpacing="2xs" />
    </>
  );
};
